<template>
    <div>

 <!-- <PermissionSettings/> -->
    </div>
</template>

<script>
//import PermissionSettings from'./PermissionSettings'
export default {
  //components : {PermissionSettings},
  data() {
    return {
    }
  },
  mounted() {
/*      var client = new ClientJS(); // Create A New Client Object
    
      var fingerprint = client.getFingerprint(); // Calculate Device/Browser Fingerprint
      sessionStorage.setItem('Uid',fingerprint);
      localStorage.setItem('Uid',fingerprint); */
      
    this.BaseURL = localStorage.getItem('BaseURL')
    if (this.BaseURL === "" || this.BaseURL === null || this.BaseURL === undefined ) 
    {
      localStorage.clear()
      this.$router.push("BasicSettings");
    }
    else{
        this.Token = localStorage.getItem('Token')
      if (this.Token === "" || this.Token === null || this.Token === undefined ) 
       {
        this.$router.push("login");
       }
       else{
        this.$router.push("Dashboard");
       }
        
    }
  }
}
</script>